import React, { useEffect, useState } from 'react'
import { Constants } from '../../CommonMethhods/Constants';
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate } from '../../CommonMethhods/CommonMethods';
import { CLIENT_FNO, APLadger, Client_Search, Dashboard_Client_Report } from '../../Configuration/API_URL';
import $ from "jquery";
import TodateComponent from '../Reports/TodateComponent';
import FromdateComponent from '../Reports/FromdateComponent';
import LoaderForSearch from '../../Components/Common/LoaderForSearch';
import { toast } from 'react-toastify';
import moment from 'moment';
import Select from "react-select";
import Header from '../../Components/Header';
import ClientFnoLossTable from '../ClientFnoLoss/ClientFnoLossTable';
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar';
import LedgerDashboard from './LedgerDashboard';
import axiosInstance, { axiosFormDataInstance } from '../../CommonMethhods/axiosInstance';

 function FinanceUpload() {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clientList, setClientList] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [scrollLoader, setScrollLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [errorResp, setErrorResp] = useState("");
    const [errorRespYe, setErrorRespYe] = useState("");
    const [errorRespMo, setErrorRespMo] = useState("");

    const [nameError, setNameError] = useState("");
    const [gridVal, setGridVal] = useState("");
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [clientNameError, setClientNameError] = useState(false);
    const [pageTable, setPageTable] = useState(1)
    const [count, setCount] = useState()
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false)
    const storeToken = localStorage.getItem("ssoToken");
    const currentYear = new Date().getFullYear();
    const [enableButton, setEnableButton] = useState(false);


const getCurrentFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  if (month < 4) {
    return `${year - 1}-${String(year).slice(2)}`;
  } else {
    return `${year}-${String(year + 1).slice(2)}`;
  }
};

const options = [
  { value: "2023-24", label: "2023-24" },
  { value: "2024-25", label: "2024-25" },
  { value: "2025-26", label: "2025-26" },
  { value: "2026-27", label: "2026-27" },
  { value: "2027-28", label: "2027-28" },
];

// ✅ Set default selected option (React Select expects full object)
const [selectedMonth, setSelectedMonth] = useState(() => {
  const currentFY = getCurrentFinancialYear();
  return options.find((opt) => opt.value === currentFY) || null;
});
    // const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileFinal, setSelectedFileFinal] = useState(null);


    console.log(selectedMonth.value, "selectedMonth");
    const [yearDataList, setYearDataList] = useState([])
    useEffect(() => {
        if (selectedMonth) {
            // getYears()
        } else {
            return
        }
    }, [selectedMonth])
    async function getYears() {
        let payload = {
            "month": selectedMonth.value
        }
        console.log(payload, "payload");

        let encPayload = AESEncryption(payload);
        try {
            const getYearList = await axiosInstance.post('https://cosmos.bajajfinservsecurities.in/api/rm/fnoloss/getfnolossyear',
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getYearList?.data);
            console.log(res, "yeardata");
            if (res.status == 0) {
                setYearDataList(res.data)
            } else {
                console.log("no data");

            }

        } catch (err) {

        }
    }
    console.log(yearDataList, "yearDataList");

    const optionsYear = yearDataList.map((year) => ({
        value: year,
        label: year.toString(),
    }));


    

    const UploadLedger = async (fileType, rmCode, pageSize = 5, offset) => {
        // debugger
    console.log('uploadedFiles', uploadedFiles);
    setEnableButton(false)
     // ✅ Reset uploaded file state after successful upload
      setUploadedFiles({});
    try {
        const formData = new FormData();

        // ✅ Append actual file(s)
        if (uploadedFiles) {
            // Case 1: If uploadedFiles is a single File
            if (uploadedFiles instanceof File) {
                formData.append("FileData", uploadedFiles);
            }
            // Case 2: If uploadedFiles is an object like {0: File, 1: File}
            else if (typeof uploadedFiles === "object") {
                Object.values(uploadedFiles).forEach((file) => {
                    if (file instanceof File) {
                        formData.append("FileData", file);
                    }
                });
            }
        } else {
            toast.error("Please upload a valid file before proceeding.");
            return;
        }
      console.log('selectedMonth',selectedMonth.value)
        formData.append("finYear", selectedMonth.value);
        const getDetails = await axiosFormDataInstance.post(
            APLadger.uploadAPLadger,
            formData,
        );

        // const res = ApiResDecrypt(getDetails?.data);
         const res = getDetails?.data;
        console.log("res client fno", res);
        // debugger
        if (res?.data) {        
            setEnableButton(false)
            const msg = res?.data;
             getClientFno("grid", "", -1, -1)
            toast.success(msg);
        } else {
            setEnableButton(false)
            setGridVal([]);
            const msg = "Issue in File Uploading";
            toast.error(res?.message);
        }

        // ✅ Always reset states safely
        setClientNameError(false);
        setLoader(false);
        setSmallLoaderExcel(false);
        setSmallLoaderPdf(false);
        setScrollLoaderTable(false);
    } catch (error) {
        console.error("Upload error:", error);
        setLoader(false);
        setSmallLoaderExcel(false);
        setSmallLoaderPdf(false);
        setServerError("Something went wrong, please try again later.");

        if (fileType === "excel" || fileType === "pdf") {
            toast.error("Something went wrong, please try again later.");
        }
    }
};



    const getClientFno = async (fileType, sapCode, pageSize = -1, offset = -1) => {
        //  debugger
        setLoader(true);
        console.log('uploadedFiles',uploadedFiles, selectedMonth)
         console.log('')
          let payloadValue = {
            finYear: selectedMonth.value,
            sapCode:  sapCode || "",
            fileType: fileType,
            PageNo: offset,
            PageSize: pageSize
        };
        console.log("payloadValue", payloadValue)
                let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                APLadger.getAPLadgerDashboard,
               `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log("res client fno", res)
            // debugger
            if (res?.data) {
                    //  debugger   
                if (fileType == "grid") {
                     setCount(res?.data?.totalCount)
                    if (offset > 1) {
                        setGridVal((prev) => {
                            return [...prev, ...res?.data?.apLadgerDetails];
                        })
                    } else {
                        setGridVal(res?.data?.apLadgerDetails);

                    }
                    // setGridVal(res?.data);
                    
                } else if (fileType == "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileType == "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                }

            } else {
                setGridVal([]);
                if (fileType == "excel") {
                    toast.error("Finance Report does not exist.");
                } else if (fileType == "pdf") {
                    toast.error("Finance Report does not exist.");
                }
            }
            setClientNameError(false);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setScrollLoaderTable(false)
        } catch (error) {
            console.log(error);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);

            setServerError("Something went wrong, Please try again later.");
            if (fileType == "excel") {
                toast.error("Something went wrong, Please try again later.");
            }
            if (fileType == "pdf") {
                toast.error("Something went wrong, Please try again later.");
            }

        }
    };


    useEffect(() => {
        // getAPLadgerReport("grid", "", 5, 1);
        //   getClientFno("grid", "", 5, 1)
        getClientFno("grid", "", -1, -1)
    }, [])

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    const handleDownloadBtn = () => {
        // debugger
        getClientFno("excel", "", -1, -1)
        // getAPLadgerReport("excel", "", -1, -1)

    }
    const handleFromDateChange = (e) => {
        if (e.target.value) {
            // setFileType("");
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setFromDate("")
            setErrorResp("");
            setServerError("");
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setToDate("")
            setErrorResp("");
            setServerError("");
        }

    };
    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    console.log("from date", fromDate, toDate)
     const handleOnClick = (e) => {
         setPageTable(1)
UploadLedger("grid", "", 5, 1);
     };
    // const customStyles = {
    //     control: (provided, state) => ({
    //         ...provided,
    //         boxShadow: "none",
    //         border: "1px solid #ccc",
    //         "&:hover": {
    //             border: "1px solid #ccc",
    //         },
    //     }),
    // };

    const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '32px',
    height: '32px',
    borderRadius: '6px',
    borderColor: state.isFocused ? '#2684FF' : '#ccc',
    backgroundColor: state.isDisabled ? '#f5f5f5' : '#fff',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    pointerEvents: state.isDisabled ? 'auto' : 'all', // allow hover cursor
    '&:hover': {
      borderColor: state.isDisabled ? '#ccc' : '#2684FF',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '32px',
    padding: '0 8px',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '32px',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
};
    const customStylesYears = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "1px solid #ccc",
            "&:hover": {
                border: "1px solid #aaa",
            },
        }),
        
    };


    // Watch state updates
    const fileData = '';
useEffect(() => {
  if (selectedFile) {
    console.log("File state updated:", selectedFile);
    setSelectedFileFinal(selectedFile)
    // sessionStorage.setItem('selectedFile',selectedFile)
  }
}, [selectedFile]);

console.log('set selectedFile 1',selectedFile)

const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (file) { 
     let payloadValue = {
            finYear: "2024-25",
            FileData: e.target.files[0],
        };
        console.log("payloadValue", payloadValue)
        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                APLadger.uploadAPLadger,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log("res client fno", res)
            if (res?.data) {
           

            } else {
              
            }
            setClientNameError(false);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setScrollLoaderTable(false)
        } catch (error) {
            console.log(error);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);

            setServerError("Something went wrong, Please try again later.");

        }
    
  }
  console.log('set Selected', selectedFile)
};


 const [image, setImage] = useState();
    const [uploadedFiles, setUploadedFiles] = useState({})
 


const handleFileUploadNew = (e, index = 0) => {
  const fileInput = e.target;
  const file = fileInput?.files?.[0];
  if (!file) return;

  // ✅ Allow only Excel files
  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const fileExtension = file.name.split('.').pop().toLowerCase();
  const sizeKB = Math.round(file.size / 1024);

  if (!allowedTypes.includes(file.type)) {
    toast.error("Only Excel files (.xls, .xlsx) are allowed and size must be under 5 MB.");
    fileInput.value = ""; // reset input
    return;
  }

  if (!["xls", "xlsx"].includes(fileExtension)) {
    toast.error("Invalid file format. Only Excel files are allowed.");
    fileInput.value = "";
    return;
  }

  if (sizeKB > 5120) {
    toast.error("File size limit is 5 MB and must be in Excel format.");
    fileInput.value = "";
    return;
  }

  // ✅ Save file data
  setImage(file);
  setEnableButton(true);
  setUploadedFiles((prev) => ({
    ...prev,
    [index ?? 0]: file,
  }));

  // ✅ Reset file input so same file can be uploaded again
  fileInput.value = "";
};


console.log('enableButton',enableButton)

    return (
        <div>
            <Header title={"Finance Document"} portal={"RM"} />
            <SingleSignOnSideBar />
            <main id="main-content" className='client-fno'>
                <div className="card-box">
                      <div>
            <h2 className="report-title">Finance Upload</h2>
          </div>
                    <div className="row input-field-wrapper" style={{ alignItems: "center", paddingTop: "3%" }}>
  {/* Optional left space */}
  <div className="col-md-3 col-sm-3 col-12"></div>

  {/* 🟩 Column 1: Select Financial Year */}
  <div className="col-md-3 col-sm-6 col-12">
    <label className="form-label">Select Financial Year<span style={{ color: "red" }}>*</span></label>
    <div className="form-group">
      <Select
        options={options}
        value={selectedMonth}
        onChange={(value) => {
          setSelectedMonth(value);
          setErrorRespMo("");
        }}
        placeholder="Search year..."
        isSearchable={true}
        styles={customStyles}
        isDisabled
      />
      {errorRespMo && (
        <span className="to-date-error month-error">{errorRespMo}</span>
      )}
    </div>
  </div>

  {/* 🟦 Column 2: Upload Document */}
  <div className="col-md-3 col-sm-6 col-12">
    <label className="form-label">Upload Document<span style={{ color: "red" }}>*</span></label>
    <div className="form-group">
      <div
        style={{
          display: "flex",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        {/* Left: File label */}
        {/* <div
          style={{
            flex: 1,
            height: "31px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #ced4da",
            borderRight: "none",
            borderRadius: "6px 0 0 6px",
            fontSize: "14px",
            color: "#333",
            whiteSpace: "nowrap",
          }}
        >
          {uploadedFiles[0]?.name || "Select Document"}
        </div> */}

<div
  style={{
    flex: 1,
    height: "31px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    border: "1px solid #ced4da",
    borderRight: "none",
    borderRadius: "6px 0 0 6px",
    fontSize: "14px",
    color: "#333",
    whiteSpace: "nowrap",
    padding: "0 10px",
    width: "200px", // ✅ Fixed width
    overflowX: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    cursor: uploadedFiles[0]?.name ? "pointer" : "default", // ✅ pointer only if file uploaded
  }}
  title={uploadedFiles[0]?.name ? uploadedFiles[0].name : ""} // ✅ hover only if file uploaded
>
  <span
    style={{
      display: "inline-block",
      minWidth: "100%",
      textOverflow: "ellipsis",
    }}
  >
    {uploadedFiles[0]?.name || "Select Document"}
  </span>
</div>

        {/* Right: Upload Button */}
        <label
          htmlFor="fileUpload"
          style={{
            flex: 1,
            height: "31px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "1px solid #007bff",
            borderRadius: "0 6px 6px 0",
            cursor: "pointer",
            fontSize: "14px",
            transition: "0.3s",
          }}
        >
          <i className="fa fa-upload" style={{ marginRight: "8px" }}></i>
          Upload 
        </label>

        {/* Hidden File Input */}
        <input
          type="file"
          id="fileUpload"
          style={{ display: "none" }}
          accept=".xls,.xlsx"
          onChange={(e) => handleFileUploadNew(e, 0)}
        />
      </div>
    </div>
  </div>
    {/* <div className="col-md-3 col-sm-3 col-12">
         <div className="table-top-nav mr-4">
            <div className="table-dt-btn">
              <button
                value="excel"
                onClick={() => {
                  getClientFno("excel", -1, -1);
                }}
                className="generate-button excel-btn"
              > <span className="icon-excelsvg"></span>
               {"Sample Excel"}
                              </button>
            </div>
          </div>
    </div> */}
</div>

                    <div className="text-center search-btn-wrapper">
                        <button
                            value="grid"
                            className="send-message"
                            onClick={handleOnClick}
                            disabled={!enableButton}
                        >
                            {Constants.uploadLeg}
                        </button>
                    </div>
                    <LedgerDashboard
                     setGridVal={setGridVal} // ✅ pass down to child
                        gridVal={gridVal}
                        smallLoaderExcel={smallLoaderExcel}
                        loader={loader}
                        setLoader={setLoader}
                        setScrollLoaderTable={setScrollLoaderTable}
                        scrollLoaderTable={scrollLoaderTable}
                        count={count}
                        getClientFno={getClientFno}
                         handleDownloadBtn={handleDownloadBtn}
                        setPageTable={setPageTable}
                        pageTable={pageTable} />
                </div>
            </main>

        </div>
    )
}

export default FinanceUpload